"use client";
import React, { useState, useEffect } from "react";
import { Offcanvas, Form } from "react-bootstrap";
import apiHandler from "../../common/api";
import DatePickup from "../DatePickup/DatePickup";
import moment from "moment";
import { useSelector } from "react-redux";
import Select from "react-select";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";

function AddStaffBlockBreakTime({
  minHoursDropdown,
  teamList,
  resourceData,
  businessId,
  callbackHandelCancle,
}) {
  console.log(resourceData, businessId, "mydata");

  console.log(teamList, "teamListteamList");

  const userData = useSelector((state) => state.user_data);
  const MySwal = withReactContent(Swal);

  const [blockTimeTypeList, setBlockTimeTypeList] = useState([]);
  const [totalBreakHours, setTotalBreakHours] = useState(0);

  const [blockTimeData, setBlockTimeData] = useState({
    resourceId: 0,
    breaktype: 0,
    date: moment().format("YYYY-MM-DD"),
    startTime: "00:00",
    endTime: "00:00",
    repeat: 0,
    tillDate: "",
    description: "",
    isApproved: 0,
    breakeTitle: "",
    isDayOff: 0,
  });

  console.log(blockTimeTypeList, "blockTimeTypeListblockTimeTypeList");

  useEffect(() => {
    if (resourceData) {
      const startTime = moment(resourceData?.start).format("HH:mm");
      let endTime = moment(resourceData?.end).format("HH:mm");

      // If endTime is "23:59", adjust it to "23:55"
      if (endTime === "23:59") {
        endTime = "00:00";
      }
      console.log("96583", startTime, endTime);
      setBlockTimeData({
        ...blockTimeData,
        ...resourceData,
        startTime,
        endTime,
      });
    }
  }, [resourceData]);

  useEffect(() => {
    calculateTotalHours(blockTimeData?.startTime, blockTimeData?.endTime);
  }, [blockTimeData]);

  useEffect(() => {
    getStaffBreakTimeTypeList(businessId);
  }, [resourceData]);

  const getStaffBreakTimeTypeList = async (bId) => {
    try {
      const { ResponseCode, ResponseData } = await apiHandler({
        method: "GET",
        route: `Business/blockedTimeTypesMasterList?businessId=${bId}`,
      });

      if (ResponseCode !== "SUCCESS")
        throw new Error("Failed to fetch team list");
      setBlockTimeTypeList(ResponseData);
    } catch (error) {
      console.error("Error fetching team data:", error);
    }
  };

  const handleCancel = (e) => {
    e.preventDefault();
    callbackHandelCancle();
  };

  const handleInputChange = (field, value) => {
    setBlockTimeData((prev) => ({ ...prev, [field]: value }));

    if (field === "repeat") {
      setBlockTimeData((prev) => ({ ...prev, tillDate: prev.date }));
    }

    if (field === "breaktype") {
      const breakDetails = blockTimeTypeList?.find((el) => el.id == value);
      console.log(breakDetails, "breakDetails");

      if (breakDetails?.duration && blockTimeData.startTime) {
        const [hours, minutes] = breakDetails.duration.split(":").map(Number);

        // Calculate new endTime by adding duration to startTime
        const newEndTime = moment(blockTimeData.startTime, "HH:mm")
          .add(hours, "hours")
          .add(minutes, "minutes")
          .format("HH:mm");

        setBlockTimeData((prev) => ({ ...prev, endTime: newEndTime }));
      }
    }

    // Automatically adjust endTime if startTime changes
    if (field === "startTime" && blockTimeData.breaktype) {
      const breakDetails = blockTimeTypeList?.find(
        (el) => el.id == blockTimeData.breaktype
      );

      if (breakDetails?.duration) {
        const [hours, minutes] = breakDetails.duration.split(":").map(Number);

        const newEndTime = moment(value, "HH:mm")
          .add(hours, "hours")
          .add(minutes, "minutes")
          .format("HH:mm");

        setBlockTimeData((prev) => ({ ...prev, endTime: newEndTime }));
      }
    }
  };

  const calculateTotalHours = (startTime, endTime) => {
    const start = moment(startTime, "HH:mm");
    const end = moment(endTime, "HH:mm");

    const duration = moment.duration(end.diff(start));
    const hours = Math.floor(duration.asHours());
    const minutes = duration.minutes();

    const formattedTime = `${hours}.${minutes.toString().padStart(2, "0")}`;
    console.log(formattedTime, "totalHours");
    setTotalBreakHours(formattedTime);
  };

  const generateShiftsForRange = (shifts, startDate, tillDate) => {
    if (tillDate) {
      const start = moment(startDate);
      const end = moment(tillDate);
      const generatedShifts = [];

      // Loop through each date from startDate to tillDate
      while (start.isSameOrBefore(end, "day")) {
        const dayId = start.isoWeekday(); // Get dayId (1 = Monday, 7 = Sunday)

        // Clone the shifts for this date
        shifts.forEach((shift) => {
          generatedShifts.push({
            ...shift,
            date: start.format("YYYY-MM-DD"),
            dayId,
            id: 0, // Ensure new shifts are marked with id 0 for backend processing
          });
        });

        // Move to the next day
        start.add(1, "day");
      }

      return generatedShifts;
    } else {
      return shifts;
    }
  };

  const handleSave = async (e) => {
    e.preventDefault();
    try {
      const shift = [
        {
          breaktype: blockTimeData?.breaktype,
          title: blockTimeData?.breakeTitle,
          description: blockTimeData?.description,
          isApproved: blockTimeData?.isApproved,
          id: blockTimeData?.id || 0,
          dayId: moment(blockTimeData?.date).isoWeekday(),
          start: blockTimeData?.startTime,
          end: blockTimeData?.endTime,
          date: blockTimeData?.date,
          // isDayOff: blockTimeData?.isDayOff,
        },
      ];

      const payloadData = {
        shifts:
          blockTimeData?.id == 0
            ? generateShiftsForRange(
                shift,
                blockTimeData?.date,
                blockTimeData?.tillDate
              )
            : shift,
        businessId,
        staffId: blockTimeData?.resourceId,
        date: blockTimeData?.date ? moment(blockTimeData?.date).format("YYYY-MM-DD") : "",
        isDayOff: blockTimeData?.isDayOff,
        tillDate: blockTimeData?.tillDate
          ? moment(blockTimeData?.tillDate).format("YYYY-MM-DD")
          : "",
        loginuserid: userData?.id,
        type: blockTimeData?.type,
      };

      console.log(payloadData, "payloadData");

      const responseData = await apiHandler({
        method: "POST",
        route: `Business/TeamShiftScheduleUpsert?businessId=${businessId}`,
        payload: payloadData,
      });

      if (responseData?.ResponseCode !== "SUCCESS") {
        console.error("Failed to fetch team list:", responseData);
        MySwal.fire({
          title: "Error",
          text:
            responseData?.ResponseMessage || "Failed to save block/break time",
          icon: "error",
          confirmButtonText: "OK",
        });
        return;
      }

      callbackHandelCancle();
    } catch (error) {
      console.error("Error fetching service data:", error);
    }
  };

  const handleDeleteBreakTimeType = async (e) => {
    e.preventDefault();
    try {
      const responseData = await apiHandler({
        method: "POST",
        route: `Business/TeamShiftDeleteByDate`,
        payload: {
          businessId,
          id: blockTimeData?.id,
          date: blockTimeData?.date,
          type: 3,
          loginuserid: userData?.id,
        },
      });

      if (responseData?.ResponseCode !== "SUCCESS") {
        console.error("Failed to fetch team list:", responseData);
        return;
      }
      callbackHandelCancle();
    } catch (error) {
      console.error("Error fetching service data:", error);
    }
  };

  const teamOptions = teamList.map((team) => ({
    value: team.id,
    label: team.fullName.trim(), // remove trailing space if any
  }));

  const breakTypeOptions = [
    { value: 0, label: "Custom (New Blocked/Break Time)" },
    ...blockTimeTypeList.map((team) => ({
      value: team.id,
      label: team.type,
    })),
  ];

  console.log(blockTimeData, "blockTimeData");

  return (
    <Offcanvas.Body className="p-4" style={{ width: "600px" }}>
      <Form className="space-y-3">
        {/* Team Member Dropdown */}
        <Form.Group className="mb-3">
          <Form.Label>Team member</Form.Label>
          {/* <Form.Select className="react-select"
            value={blockTimeData.resourceId}
            onChange={(e) => handleInputChange("resourceId", e.target.value)}
          >
            {teamList.map((team, i) => (
              <option key={i + 1} value={team.id}>
                {team.fullName}
              </option>
            ))}
          </Form.Select> */}

          <Select
            className="react-select-container"
            classNamePrefix="react-select"
            // styles={customStyles}
            options={teamOptions}
            value={teamOptions.find(
              (opt) => opt.value === blockTimeData.resourceId
            )}
            onChange={(selectedOption) =>
              handleInputChange("resourceId", selectedOption.value)
            }
          />
        </Form.Group>

        {/* Type Dropdown */}
        <Form.Group className="mb-3">
          <Form.Label>Type</Form.Label>
          {/* <Form.Select
            value={blockTimeData.breaktype}
            onChange={(e) => handleInputChange("breaktype", e.target.value)}
          >
            <option key={0} value={0}>
              Custom (New Blocked/Break Time)
            </option>
            {blockTimeTypeList.map((team, i) => (
              <option key={i + 1} value={team.id}>
                {team.type}
              </option>
            ))}
          </Form.Select> */}
          <Select
            className="react-select-container"
            classNamePrefix="react-select"
            // styles={breakTypeStyles}
            options={breakTypeOptions}
            value={breakTypeOptions.find(
              (opt) => opt.value === blockTimeData.breaktype
            )}
            onChange={(selectedOption) =>
              handleInputChange("breaktype", selectedOption.value)
            }
          />
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>Title</Form.Label>
          <Form.Control
            type="text"
            value={blockTimeData.breakeTitle || ""}
            onChange={(e) => handleInputChange("breakeTitle", e.target.value)}
          />
        </Form.Group>

        <Form.Group className="mb-3 d-flex gap-2">
          <Form.Group className="">
            <Form.Label>Blocked/Break Type</Form.Label>
            <div className="d-flex align-items-center gap-2">
              <Form.Check
                type="checkbox"
                checked={blockTimeData.isDayOff == 0}
                onChange={(e) =>
                  handleInputChange("isDayOff", e.target.checked ? 0 : 1)
                }
              />
              <label className="text-color-70  margin-top-2">Break</label>
            </div>
          </Form.Group>
          <Form.Group className="">
            <Form.Label>Leave</Form.Label>
            <div className="d-flex align-items-center gap-2">
              <Form.Check
                type="checkbox"
                checked={blockTimeData.isDayOff == 1}
                onChange={(e) =>
                  handleInputChange("isDayOff", e.target.checked ? 1 : 0)
                }
              />
              <label className="text-color-70  margin-top-2">
                Blocked (Leave)
              </label>
            </div>
          </Form.Group>
        </Form.Group>

        {/* Start Date Picker */}
        {blockTimeData.date && (
          <Form.Group className="mb-3">
            <Form.Label>Start date</Form.Label>
            <DatePickup
              filterDate={blockTimeData.date}
              // showDefaultDate={true}
              handleDateChange={(date) => handleInputChange("date", date)}
            />
          </Form.Group>
        )}

        {/* Start & End Time Dropdowns */}
        <div className="d-flex gap-2 mb-3">
          <Form.Group className="col-6">
            <Form.Label>Start time</Form.Label>
            <Form.Select
              value={blockTimeData.startTime}
              onChange={(e) => handleInputChange("startTime", e.target.value)}
            >
              {minHoursDropdown.map((time, i) => (
                <option key={i} value={time.value}>
                  {time.label}
                </option>
              ))}
            </Form.Select>
          </Form.Group>

          <Form.Group className="col-6">
            <Form.Label>End time</Form.Label>
            <Form.Select
              value={blockTimeData.endTime}
              onChange={(e) => handleInputChange("endTime", e.target.value)}
            >
              {minHoursDropdown.map((time, i) => (
                <option key={i} value={time.value}>
                  {time.label}
                </option>
              ))}
            </Form.Select>
          </Form.Group>
        </div>

        {/* Repeat Checkbox */}
        {blockTimeData?.id == 0 && (
          <Form.Group className="mb-3 d-flex align-items-center gap-2">
            <div className="d-flex align-items-center gap-2">
              <Form.Check
                type="checkbox"
                checked={blockTimeData.repeat == 1}
                onChange={(e) =>
                  handleInputChange("repeat", e.target.checked ? 1 : 0)
                }
              />
              <label className="text-color-70  margin-top-2">Repeat</label>
            </div>
          </Form.Group>
        )}

        {/* Repeat Until Date Picker */}
        {blockTimeData.repeat === 1 && blockTimeData.id == 0 && (
          <Form.Group className="mb-3">
            <Form.Label>Repeat until</Form.Label>
            <DatePickup
              filterDate={blockTimeData.tillDate}
              //   showDefaultDate={true}
              handleDateChange={(date) => handleInputChange("tillDate", date)}
            />
          </Form.Group>
        )}

        {/* Description Field */}
        <Form.Group className="mb-3">
          <Form.Label>Description</Form.Label>
          <Form.Control
            as="textarea"
            rows={2}
            maxLength={100}
            value={blockTimeData.description}
            onChange={(e) => handleInputChange("description", e.target.value)}
          />
          <small>{blockTimeData.description?.length}/100</small>
        </Form.Group>

        {/* Approved Checkbox */}
        <Form.Group className="mb-3 d-flex align-items-center gap-2">
          <div className="d-flex align-items-center gap-2">
            <Form.Check
              type="checkbox"
              checked={blockTimeData.isApproved == 1}
              onChange={(e) =>
                handleInputChange("isApproved", e.target.checked ? 1 : 0)
              }
            />
            <label className="text-color-70  margin-top-2">Approved</label>
          </div>
          <span className="ms-auto text-color-70">
            Time off total: {totalBreakHours}h
          </span>
        </Form.Group>

        {/* Buttons */}
        <div className="d-flex">
          <div className="d-flex ms-auto gap-2">
            {blockTimeData.id > 0 && (
              <button
                onClick={(e) => handleDeleteBreakTimeType(e)}
                className=" btn btn-primary btn-sm me-2 mb-2"
              >
                Delete
              </button>
            )}
            <button
              onClick={handleCancel}
              className="btn btn-outline-primary btn-sm me-2 mb-2"
            >
              Cancel
            </button>
            <button
              className="btn btn-primary btn-sm me-2 mb-2"
              onClick={handleSave}
            >
              Save
            </button>
          </div>
        </div>
      </Form>
    </Offcanvas.Body>
  );
}

export default AddStaffBlockBreakTime;
